import React from "react";
import { motion } from "framer-motion";

export default function WaveformSlider({ currentTime, duration, setCurrentTime, audioRef, isPlaying, setIsPlaying }) {
    const numBars = 30; // Number of bars

    const handleSliderChange = (e) => {
        const newTime = Number(e.target.value);
        audioRef.current.currentTime = newTime;
        setCurrentTime(newTime);

        if (!isPlaying) {
            audioRef.current.play();
            setIsPlaying(true);
        }
    };

    const danceGradientColors = [
        "#FF00AA", // Pink
        "#00FFCC", // Cyan
        "#FFFF00", // Yellow
        "#00FFFF", // Aqua
        "#FF00FF", // Magenta
    ];

    return (
        <div className="relative w-full flex items-center justify-center">
            {/* Animated Waveform Bars */}
            <div className="relative flex w-full h-12 items-center justify-between">
                {Array.from({ length: numBars }).map((_, i) => {
                    const progress = i / numBars; // Waveform progress
                    const isPlayed = progress <= currentTime / duration; // Has it been played?
                    const height = Math.sin(progress * Math.PI) * 20 + 5; // Height variation
                    const colorIndex = Math.floor((progress * danceGradientColors.length) % danceGradientColors.length);
                    const barColor = danceGradientColors[colorIndex];

                    return (
                        <motion.div
                            key={i}
                            initial={{ height: `${height}px`, opacity: 0.6 }}
                            animate={
                                isPlaying
                                    ? {
                                        height: `${Math.sin(progress * Math.PI + (currentTime / duration) * 6) * 20 + 10}px`,
                                        opacity: 1,
                                    }
                                    : { height: `${height}px`, opacity: 0.6 }
                            }
                            transition={
                                isPlaying
                                    ? {
                                        duration: 0.3,
                                        repeat: Infinity,
                                        repeatType: "mirror",
                                        ease: "easeInOut",
                                    }
                                    : {}
                            }
                            className={`w-[5px] rounded-lg mx-[2px]`}
                            style={{ backgroundColor: isPlayed ? barColor : "#ccc" }}
                        />
                    );
                })}
            </div>
            {/* Hidden input range */}
            <input
                type="range"
                min="0"
                max={duration || 1}
                value={currentTime}
                onInput={handleSliderChange} // Live updates
                className="absolute inset-0 w-full h-full opacity-0 cursor-pointer"
            />
        </div>
    );
}